export const updateTimeZoneOffset = (date) => {
  const newDate = new Date(date);
  const fixedDate = newDate.setMinutes(
    newDate.getMinutes() + newDate.getTimezoneOffset()
  );
  return fixedDate;
};

export const removeTZ = (oldDate) => {
  const oldDateNumber = new Date(oldDate);
  const oldDateOffset = new Date(oldDate).getTimezoneOffset() * 60000;
  const newDate = new Date(oldDateNumber - oldDateOffset).toISOString();

  return newDate;
};
